module.exports = __webpack_public_path__ + "static/img/word_big.f05de0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/word_big.png
// module id = N9Hl
// module chunks = 0